import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-auth-callback',
  template: `<p>Authenticating...</p>`,
})
export class AuthCallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private route = inject(ActivatedRoute);

  async ngOnInit(): Promise<void> {
    const token = this.route.snapshot.queryParamMap.get('token') ?? '';

    if (!token) {
      window.location.replace('/login?error=no_token');
      return;
    }

    try {
      this.authService.handleCallback(token);
      await firstValueFrom(this.authService.getAuthUserData());
      window.location.replace('/incidents');
    } catch {
      window.location.replace('/login?error=auth_failed');
    }
  }
}
